import Result from "@/core/common/Result";

export interface IBase64Converter {
  convert(file: File | undefined): Promise<Result<string>>;
}

export const Base64DI = Symbol("base64converter");
